export enum FilterGroup {
  AssetClasFilterGroup = 'AssetClass',
  ProductTypeFilterGroup = 'ProductType',
}
